module.exports = __webpack_public_path__ + "img/food-dish-waiter.a6941795.svg";